module.exports = __webpack_public_path__ + "img/upload.9ee90e3c.svg";